import usePeppolNudge from 'hooks/Peppol/usePeppolNudge';
import { FC } from 'react';
import Dot from './Dot';

const PeppolActionDot: FC<{ className?: string }> = ({ className }) => {
  const isPeppolNudge = usePeppolNudge();

  if (!isPeppolNudge) return null;

  return <Dot className={className} />;
};

export default PeppolActionDot;
